import { getProperty } from "dot-prop";
import { Component, createEffect, createMemo, For, Show } from "solid-js";
import { isTaxType, MeasurementUnit, taxType, taxTypeNames } from "~/mydata";
import { InvoiceItem, ItemTax, itemTaxAmount } from "~/onesign/invoice-totals";
import { findTax, taxMeta } from "~/onesign/taxes";
import { itemTax } from "~/schemas/invoice-item";
import { createZodForm } from "~/zod-forms";
import AmountFormControl from "./AmountFormControl";
import Button from "./Button";
import { maybeNumber, maybeType } from "./helpers";
import SelectFormControl from "./SelectFormControl";

const AddInvoiceItemTaxForm: Component<{
  item: InvoiceItem;
  addTaxItem(item: ItemTax): void;
}> = (props) => {
  const initialInput = {
    type: undefined,
    category: undefined,
    customAmount: undefined,
    inputAmount: undefined
  };
  // async handleSubmit(tax) {
  //   props.addTaxItem(tax);
  //   form.reset(initialInput);
  // },
  const [Form, form] = createZodForm({
    schema: itemTax,
    initialInput,
  });
  const [type, setType] = form.bind("type");
  const [category, setCategory] = form.bind("category");
  const [customAmount, setCustomAmount] = form.bind("customAmount");

  const taxCategories = createMemo(() => {
    const type_ = type();
    return taxMeta.filter(
      (m) =>
        getProperty(m, "taxCategory") !== undefined &&
        getProperty(m, "taxType") === type_
    );
  });
  const taxAmount = createMemo(() => {
    const item = props.item;
    const tax = form.output();
    return tax && itemTaxAmount(tax, item);
  });
  const chosenTax = createMemo(() => {
    const t = type();
    const c = category();
    return t && findTax(t, c);
  });
  const hasCustomAmount = () =>
    getProperty(chosenTax() ?? {}, "customAmount", false);
  const isValid = () =>
    hasCustomAmount()
      ? taxAmount()?.greaterThan(0) ?? false
      : taxAmount()?.greaterThanOrEqualTo(0) ?? false;
  createEffect(() =>
    console.log({
      tax: form.output(),
      input: form.input(),
      amount: taxAmount(),
      inputAmount: inputAmount(),
      hasC: hasCustomAmount(),
      isValid: isValid(),
    })
  );
  const inputAmount = createMemo(() => {
    const custom = hasCustomAmount();
    const calculatedAmount = taxAmount();
    const customAmount_ = customAmount();
    console.debug({ custom, calculatedAmount, customAmount_ });
    return custom
      ? customAmount_ ?? "0"
      : calculatedAmount?.toFixed(2) ?? "0";
  });
  return (
    <Form
      class="mb-4"
      handleSubmit={(input) => {
        props.addTaxItem({
          type: input.type,
          category: input.category,
          customAmount: input.customAmount,
          inputAmount: !hasCustomAmount()
            ? inputAmount()
            : "0"
        })
        form.reset(initialInput);
      }}
    >
      <div class="row gx-2 ">
        <div class="col-md-3 me-3">
          <SelectFormControl
            label="Τύπος φόρου"
            value={type()}
            errors={type.dirty && type.issues}
            onChange={(e) =>
              setType(maybeType(isTaxType)(Number(e.currentTarget.value)))
            }
            classList={{
              ["p-2"]: true,
            }}
          >
            <option value="" selected={type() === undefined}>
              Επιλέξτε τύπο...
            </option>
            <For each={Object.entries(taxTypeNames)}>
              {([id, name]) => <option value={id}>{name}</option>}
            </For>
          </SelectFormControl>
        </div>
        <div class="col me-3 no-margin-right">
          <SelectFormControl
            label="Κατηγορία"
            disabled={type() === taxType.Deductions || type() === undefined}
            style="text-overflow: ellipsis"
            value={category()}
            errors={category.dirty && category.issues}
            onChange={(e) => setCategory(maybeNumber(e.currentTarget.value))}
            classList={{
              ["p-2"]: true,
            }}
          >
            <option value="">Επιλέξτε κατηγορία...</option>
            <For each={taxCategories()}>
              {(c) => <option value={c.taxCategory}>{c.title}</option>}
            </For>
          </SelectFormControl>
        </div>
        <div class="col-md-3">
          <label class="form-label">Προσθήκη φόρου (€)</label>
          <div class="input-group">
            <AmountFormControl
              disabled={!hasCustomAmount()}
              signal={[() => String(inputAmount()), setCustomAmount]}
              debounce={700}
              classList={{
                "is-invalid":
                  customAmount.dirty && customAmount.issues.length > 0,
                ["pe-2"]: true,
              }}
              value={inputAmount()}
            />

            <Button
              disabled={!isValid()}
              class="form-control"
              kind="primary"
              style="flex: 0 1 fit-content"
            >
              +
            </Button>
          </div>
        </div>
      </div>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <Show when={type()}>
            <li class="breadcrumb-item">{taxTypeNames[type()!]}</li>
          </Show>
          <Show when={chosenTax()}>
            <li class="breadcrumb-item" style="max-width: 32em">
              {chosenTax()!.title}
            </li>
          </Show>
        </ol>
      </nav>
    </Form>
  );
};
export default AddInvoiceItemTaxForm;
